<h2 mat-dialog-title>Salva fattura come Bozza</h2>
    <mat-dialog-content>
      <p>Vuoi finalizzare la fattura?</p>
      <p>Per il momento non verrà inviata all'esterno. Potrai rivederla e modificarla quando vuoi nel menù "Bozze salvate", vedere l'anteprima del PDF ed eventualmente pubblicarla.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Indietro</button>
      <button mat-raised-button color="primary" (click)="confirm()">
        <mat-icon>check</mat-icon>
        Confermo
      </button>
    </mat-dialog-actions>
